export default {"src":"/_next/static/media/laboratory-online-doctor.841e301d.svg","height":368,"width":396,"blurWidth":0,"blurHeight":0};